// TODO: CONVERT TO TYPESCRIPT
import React, { useContext } from 'react'
import PropTypes from 'prop-types'
import { texasVptsReportPath } from 'components/routes/external'
import { createReviewPath, reviewWithSupplierPath } from 'components/routes/path'
import { AuthContext, USER_TYPES, verifiedAgencyUser } from 'components/common/auth/AuthContext'

const ReviewCreateButton = ({ supplierId, className, text }) => {
  const authContext = useContext(AuthContext)

  const renderButton = (href, dataMethod, theText) => (
    <a
      href={href}
      data-method={dataMethod}
      className={`button pro-orange-400 supplier-profile-button ${className}`}
    >
      {theText}
    </a>
  )

  const renderButtonForUser = () => {
    if (authContext.isTxVpts) {
      return renderButton(texasVptsReportPath(), 'post', 'Submit a Vendor Performance Report')
    } else if (verifiedAgencyUser(authContext)) {
      return renderButton(createReviewPath(supplierId), 'post', text)
    } else if (authContext.userType === USER_TYPES.UNAUTHED) {
      return renderButton(reviewWithSupplierPath(supplierId), 'get', text)
    } else {
      return null
    }
  }

  return (
    renderButtonForUser()
  )
}

ReviewCreateButton.propTypes = {
  supplierId: PropTypes.number.isRequired,
  className: PropTypes.string
}

export default ReviewCreateButton
